<script>
import Navbar from "@/components/navbar";
import FooterBG from "@/components/footer-bg";
import Contacts from "@/components/contact-bg";

export default {
  components: {
    Navbar,
    // Partners,
    // Contact,
    FooterBG,
    Contacts,
  }
};
</script>
<style scoped>
@media (max-width: 770px) {
  h4
  {
    font-size: 0.5rem;
    letter-spacing: 1px !important;
    padding-top: 4%;
  }
}
.black-text{
  color: rgba(167, 112, 8, 0.828);
}
.background-color
{
  background-color: rgba(240, 248, 255, 0.796);
  border-radius: 20px;
  width: 35%;
  padding-top: 0.2%;
  padding-bottom: 0.2%;
}
h4
{
  letter-spacing: 0.3rem;
}
</style>
<template>
  <div>
    <Navbar />

    <div v-scroll-spy>
      <!--START HOME-->
      <section
        class="section bg-home height-100vh"
        id="home"
        :style="{'background-image': 'url(' + require('@/assets/images/fanmath-images/contacts2.jpg') + ')', 'background-size': 'cover','background-position': 'center' }"
      >
      <div class="bg-overlay"></div>
        <div class>
          <div class>
            <div class="container slidero">
              <div class="row">
                <div class="col-lg-8 offset-lg-2 text-white text-center">
                  <h1 style="color: orange;" class="home-title">Контакти</h1>
                 
                  <p
                    class="padding-t-15 home-desc mx-auto"
                  ></p>
                </div>
                <!-- <div style="position: relative; left: 33%; text-align: center;" class="background-color">
                <h4 class="home-small-title black-text">Телефонен номер: <br>+359 889 469 526</h4>
                  <h4 class="home-small-title black-text">Имейл адрес: <br>tanilieva@mail.bg</h4>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- Particles -->
        <!-- <vue-particles class="position-relative" color="#FFF"></vue-particles> -->
        
      </section>

      <!--END HOME-->
      <!-- <Contact /> -->
      <!-- <Partners /> -->
      <Contacts/>
      <FooterBG />
    </div>
  </div>
</template>

<style scoped>
  .home-title
  {
    background-color: rgba(240, 248, 255, 0.811);
    width: 100%;
    border-radius: 20px;
    height: 70%;
  }
::v-deep .modal-content {
  background-color: #000000;
  color: white;
  background: none;
  border: none;
}
::v-deep .modal-header {
  border: none;
}
::v-deep .modal-backdrop {
  opacity: 0.5;
}
</style>